var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "logoutAccount" },
    [
      _c("header-item", {
        attrs: {
          "title-array": _vm.titleArray,
          "title-mb": _vm.titleArray[0],
          "type-next": "click"
        },
        on: { navBarClick: _vm.navBarClick }
      }),
      _c("div", { staticClass: "formClass" }, [
        _vm.currentIndex == 0
          ? _c("div", { staticClass: "logout_flex" }, [
              _c(
                "div",
                {
                  staticClass: "logout_div",
                  on: {
                    click: function($event) {
                      return _vm.btn_click(1)
                    }
                  }
                },
                [
                  _c("p", [_vm._v("账号注销")]),
                  _c("p", [_vm._v("您可以通过申请账号注销，注销您的账号")])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "logout_div",
                  on: {
                    click: function($event) {
                      return _vm.btn_click(2)
                    }
                  }
                },
                [
                  _c("p", [_vm._v("单手游注销")]),
                  _c("p", [
                    _vm._v(
                      " 您可以通过单手游注销删除雷霆旗下的某款游戏的 数据，并不影响整个雷霆账号的使用 "
                    )
                  ])
                ]
              )
            ])
          : _vm._e(),
        _vm.currentIndex == 1
          ? _c("div", [
              _vm.$isFlag
                ? _c(
                    "div",
                    { staticStyle: { padding: "0 0.4rem" } },
                    [
                      _c("van-cell", {
                        attrs: { title: "申请雷霆账号注销", "is-link": "" },
                        on: {
                          click: function($event) {
                            return _vm.btn_click(3)
                          }
                        }
                      }),
                      _c("van-cell", {
                        attrs: { title: "取消申请雷霆账号注销", "is-link": "" },
                        on: {
                          click: function($event) {
                            return _vm.btn_click(4)
                          }
                        }
                      }),
                      _c("van-cell", {
                        attrs: { title: "申请非雷霆账号注销", "is-link": "" },
                        on: { click: _vm.applyNoLeiting }
                      })
                    ],
                    1
                  )
                : _c("div", { staticClass: "logout_flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "logout_div",
                        on: {
                          click: function($event) {
                            return _vm.btn_click(3)
                          }
                        }
                      },
                      [
                        _c("p", [_vm._v("申请账号注销")]),
                        _c("p", [
                          _vm._v("您可以通过申请账号注销，注销您的账号")
                        ])
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "logout_div",
                        on: {
                          click: function($event) {
                            return _vm.btn_click(4)
                          }
                        }
                      },
                      [
                        _c("p", [_vm._v("取消账号注销申请")]),
                        _c("p", [
                          _vm._v("您可以通过取消申请账号注销，取消注销您的账号")
                        ])
                      ]
                    )
                  ])
            ])
          : _vm._e(),
        _vm.currentIndex == 2
          ? _c("div", [
              _vm.$isFlag
                ? _c(
                    "div",
                    { staticStyle: { padding: "0 0.4rem" } },
                    [
                      _c("van-cell", {
                        attrs: { title: "申请单手游注销", "is-link": "" },
                        on: {
                          click: function($event) {
                            return _vm.btn_click(5)
                          }
                        }
                      }),
                      _c("van-cell", {
                        attrs: { title: "取消单手游注销申请", "is-link": "" },
                        on: {
                          click: function($event) {
                            return _vm.btn_click(13)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _c("div", { staticClass: "logout_flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "logout_div",
                        on: {
                          click: function($event) {
                            return _vm.btn_click(5)
                          }
                        }
                      },
                      [
                        _c("p", [_vm._v("申请单手游注销")]),
                        _c("p", [
                          _vm._v(
                            " 您可以通过单手游注销删除雷霆旗下的某款游戏的 数据，并不影响整个雷霆账号的使用 "
                          )
                        ])
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "logout_div",
                        on: {
                          click: function($event) {
                            return _vm.btn_click(13)
                          }
                        }
                      },
                      [
                        _c("p", [_vm._v("取消单手游注销申请")]),
                        _c("p", [
                          _vm._v(
                            "您可以通过取消申请单手游注销，取消注销您的账号 下的手游"
                          )
                        ])
                      ]
                    )
                  ])
            ])
          : _vm._e(),
        _vm.currentIndex == 3
          ? _c(
              "div",
              { staticClass: "content" },
              [
                _vm._m(0),
                _vm._m(1),
                _c(
                  "van-checkbox",
                  {
                    staticClass: "checkbox",
                    model: {
                      value: _vm.checked,
                      callback: function($$v) {
                        _vm.checked = $$v
                      },
                      expression: "checked"
                    }
                  },
                  [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("我已阅读、理解并同意")
                    ]),
                    _c(
                      "span",
                      {
                        staticStyle: { color: "#626fdd" },
                        on: { click: _vm.ltRule }
                      },
                      [_vm._v("《雷霆账号注销须知》")]
                    ),
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v(
                        "的全部内容，特别是红色及加粗字体部分的警示信息。我确认申请注销的账号满足所有前提条件，并自愿承担注销带来的全部后果。"
                      )
                    ])
                  ]
                ),
                _c(
                  "van-button",
                  {
                    staticClass: "formClass_btn",
                    attrs: {
                      round: "",
                      block: "",
                      type: "info",
                      "native-type": "submit",
                      color: "#616edf",
                      disabled: _vm.disabledBtn
                    },
                    on: {
                      click: function($event) {
                        return _vm.confirmSub()
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.btnText == 0
                          ? "确认提交"
                          : "请确认上述信息 " + _vm.btnText + " 秒"
                      )
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        [4, 6, 13, 11].includes(_vm.currentIndex)
          ? _c(
              "div",
              [
                _c(
                  "van-form",
                  {
                    staticClass: "commonFromClass",
                    on: { submit: _vm.logoutInfoClick }
                  },
                  [
                    _vm.currentIndex == 11
                      ? _c("common-select", {
                          staticClass: "selectGame",
                          attrs: {
                            "selection-info": {
                              selectName: "所玩游戏",
                              columns: _vm.userInfo.gameList,
                              label: "gameName",
                              val: "game"
                            }
                          },
                          on: { emitParentVal: _vm.emitParentVal }
                        })
                      : _vm._e(),
                    _vm.getPhoneVis("bindPhone")
                      ? _c("van-field", {
                          style: [13, 11].includes(_vm.currentIndex)
                            ? ""
                            : "border-radius: 16px 16px 0 0",
                          attrs: { readonly: "", label: "认证手机号" },
                          model: {
                            value: _vm.userInfo.phone,
                            callback: function($$v) {
                              _vm.$set(_vm.userInfo, "phone", $$v)
                            },
                            expression: "userInfo.phone"
                          }
                        })
                      : _vm._e(),
                    _vm.getPhoneVis("bindPhone")
                      ? _c("van-field", {
                          staticStyle: { "border-radius": "0 0 16px 16px" },
                          attrs: {
                            maxlength: "6",
                            label: "短信验证码",
                            rules: _vm.rules.codeRules
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "button",
                                fn: function() {
                                  return [
                                    !_vm.showTime
                                      ? _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              color: "#616edf",
                                              cursor: "pointer"
                                            },
                                            on: { click: _vm.getCode }
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(_vm.timeMsg) + " "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              color: "#878787",
                                              cursor: "pointer"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(_vm.codeTime) + " S "
                                            )
                                          ]
                                        )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            1632184688
                          ),
                          model: {
                            value: _vm.applayParams.code,
                            callback: function($$v) {
                              _vm.$set(_vm.applayParams, "code", $$v)
                            },
                            expression: "applayParams.code"
                          }
                        })
                      : _vm._e(),
                    _vm.getPhoneVis("bindPhone")
                      ? _c("p", { staticClass: "from_p" }, [
                          _vm._v(" *如果一分钟内没有收到验证码请重新获取 ")
                        ])
                      : _vm._e(),
                    _vm.getPhoneVis("bindIdentity")
                      ? _c("van-field", {
                          staticStyle: { "border-radius": "16px 16px 0 0" },
                          attrs: { label: "姓名", rules: _vm.rules.nameRules },
                          model: {
                            value: _vm.applayParams.realName,
                            callback: function($$v) {
                              _vm.$set(_vm.applayParams, "realName", $$v)
                            },
                            expression: "applayParams.realName"
                          }
                        })
                      : _vm._e(),
                    _vm.getPhoneVis("bindIdentity")
                      ? _c("van-field", {
                          staticStyle: { "border-radius": "0 0 16px 16px" },
                          attrs: {
                            label: "身份证号",
                            rules: _vm.rules.idRules
                          },
                          model: {
                            value: _vm.applayParams.idCard,
                            callback: function($$v) {
                              _vm.$set(_vm.applayParams, "idCard", $$v)
                            },
                            expression: "applayParams.idCard"
                          }
                        })
                      : _vm._e(),
                    _c(
                      "van-checkbox",
                      {
                        staticClass: "checkbox",
                        model: {
                          value: _vm.checked2,
                          callback: function($$v) {
                            _vm.checked2 = $$v
                          },
                          expression: "checked2"
                        }
                      },
                      [
                        _vm._v("我已阅读并同意 "),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "#626fdd" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.ltUserRule($event)
                              }
                            }
                          },
                          [_vm._v("《雷霆游戏用户隐私政策》")]
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: { color: "#626fdd" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.ltGameRule($event)
                              }
                            }
                          },
                          [_vm._v("《雷霆游戏用户协议》")]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "bottom" },
                      [
                        _c(
                          "van-button",
                          {
                            staticClass: "formClass_btn",
                            attrs: {
                              round: "",
                              block: "",
                              type: "info",
                              "native-type": "submit",
                              color: "#616edf"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  [4, 13].includes(_vm.currentIndex)
                                    ? "确定取消注销"
                                    : "确定注销"
                                ) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.currentIndex == 5
          ? _c(
              "div",
              { staticClass: "content" },
              [
                _vm._m(2),
                _c("p", [
                  _vm._v(
                    " ● 1. 游戏账号注销成功后此账号重新登录该游戏的时候游戏进度将会被重置； "
                  )
                ]),
                _vm._m(3),
                _c("p", [
                  _vm._v(
                    " ● 3. 游戏账号注销之后，雷霆公司有权不再为用户提供任何该与该游戏进度有关的服务； "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    " ● 4. 因注销游戏账号所带来的不便或不利后果，由用户自行承担，与雷霆公司无关； "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    " ● 5. 如果游戏账号注销期间存在账号归属纠纷，雷霆公司有权终止注销申请； "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    " ● 6. 如果您的游戏账号实名认证信息年龄未满14周岁，根据《个人信息保护法》相关规定，您在申请游戏账号注销前，需要获得您父母或其他监护人同意； "
                  )
                ]),
                _c("p", [
                  _vm._v(
                    " ● 7. 游戏账号注销期间取消注销申请后，需要间隔24小时后方可再次申请。 "
                  )
                ]),
                _vm._m(4),
                _c(
                  "van-checkbox",
                  {
                    staticClass: "checkbox",
                    model: {
                      value: _vm.checked3,
                      callback: function($$v) {
                        _vm.checked3 = $$v
                      },
                      expression: "checked3"
                    }
                  },
                  [
                    _vm._v("我已阅读并同意"),
                    _c(
                      "span",
                      {
                        staticStyle: { color: "#626fdd" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.ltRule($event)
                          }
                        }
                      },
                      [_vm._v("《雷霆账号注销须知》")]
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: { color: "#626fdd" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.ltRule2($event)
                          }
                        }
                      },
                      [_vm._v("《雷霆账号游戏注销须知》")]
                    )
                  ]
                ),
                _c(
                  "van-button",
                  {
                    staticClass: "formClass_btn",
                    attrs: {
                      round: "",
                      block: "",
                      type: "info",
                      "native-type": "submit",
                      color: "#616edf",
                      disabled: _vm.disabledBtn
                    },
                    on: { click: _vm.gameLogOut }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.btnText == 0
                          ? "确认提交"
                          : "请确认上述信息 " + _vm.btnText + " 秒"
                      )
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _vm.currentIndex == 7
          ? _c("div", { staticClass: "gameListClass" }, [
              _c("p", { staticClass: "title" }, [
                _vm._v(
                  " 您的雷霆账号注销成功，以下数据也会一并清除或者匿名化，并且无法恢复 "
                )
              ]),
              _c(
                "div",
                { staticClass: "list" },
                [
                  _vm._m(5),
                  _vm.userInfo.gameReCharge.length == 0
                    ? _c(
                        "p",
                        {
                          staticStyle: {
                            "text-align": "center",
                            "font-size": "0.32rem",
                            color: "#999",
                            margin: "1rem 0"
                          }
                        },
                        [_vm._v(" 暂无数据 ")]
                      )
                    : _vm._e(),
                  _vm._l(_vm.userInfo.gameReCharge, function(el, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "list_title gameName",
                        style:
                          index % 2 == 0
                            ? "background:#fff"
                            : "background:#fafafb"
                      },
                      [
                        _c(
                          "p",
                          {
                            style: el.hasReCharge ? "color:red !important" : ""
                          },
                          [_vm._v(" " + _vm._s(el.game) + " ")]
                        ),
                        _c(
                          "p",
                          {
                            style: el.hasReCharge ? "color:red !important" : ""
                          },
                          [
                            _vm._v(
                              " " + _vm._s(el.hasReCharge ? "是" : "否") + " "
                            )
                          ]
                        )
                      ]
                    )
                  })
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "button_class" },
                [
                  _c(
                    "van-button",
                    {
                      staticClass: "formClass_btn",
                      attrs: {
                        round: "",
                        block: "",
                        type: "info",
                        color: "#616edf"
                      },
                      on: {
                        click: function($event) {
                          return _vm.cancelClick(1)
                        }
                      }
                    },
                    [_vm._v("确定注销")]
                  ),
                  _c(
                    "van-button",
                    {
                      staticClass: "formClass_btn",
                      attrs: {
                        round: "",
                        plain: "",
                        type: "info",
                        color: "#616edf"
                      },
                      on: {
                        click: function($event) {
                          return _vm.cancelClick(2)
                        }
                      }
                    },
                    [_vm._v("终止注销")]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm.currentIndex == 8 || _vm.currentIndex == 12
          ? _c("div", { staticClass: "chooseReason" }, [
              !_vm.$isFlag
                ? _c("p", { staticClass: "title" }, [
                    _vm._v(
                      " 您的雷霆账号注销成功，以下数据也会一并清除或者匿名化，并且无法恢复 "
                    )
                  ])
                : _c("p", { staticClass: "title" }, [
                    _vm._v("请选择您注销的原因")
                  ]),
              _c(
                "div",
                { staticClass: "chooseContent" },
                [
                  _c(
                    "van-checkbox-group",
                    {
                      staticClass: "chooseCheck",
                      model: {
                        value: _vm.logOffInfo.destroyReason,
                        callback: function($$v) {
                          _vm.$set(_vm.logOffInfo, "destroyReason", $$v)
                        },
                        expression: "logOffInfo.destroyReason"
                      }
                    },
                    _vm._l(_vm.chooseList, function(item, index) {
                      return _c(
                        "van-checkbox",
                        { key: index, attrs: { name: item.name } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  ),
                  _c("van-field", {
                    staticClass: "textAreaClass",
                    staticStyle: { "margin-bottom": "0.2rem" },
                    attrs: {
                      rows: "2",
                      autosize: "",
                      type: "textarea",
                      maxlength: "200",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.logOffInfo.reason,
                      callback: function($$v) {
                        _vm.$set(_vm.logOffInfo, "reason", $$v)
                      },
                      expression: "logOffInfo.reason"
                    }
                  }),
                  _c("van-field", {
                    staticClass: "textAreaClass",
                    attrs: {
                      rows: "4",
                      autosize: "",
                      type: "textarea",
                      maxlength: "200",
                      "show-word-limit": "",
                      label: "游戏建议"
                    },
                    model: {
                      value: _vm.logOffInfo.gameAdvice,
                      callback: function($$v) {
                        _vm.$set(_vm.logOffInfo, "gameAdvice", $$v)
                      },
                      expression: "logOffInfo.gameAdvice"
                    }
                  }),
                  _c(
                    "div",
                    { staticClass: "button_class" },
                    [
                      _c(
                        "van-button",
                        {
                          staticClass: "formClass_btn",
                          attrs: {
                            round: "",
                            block: "",
                            type: "info",
                            color: "#616edf"
                          },
                          on: { click: _vm.confirmCancel }
                        },
                        [_vm._v("确定注销")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm.currentIndex == 9
          ? _c(
              "div",
              { staticClass: "collapse" },
              [
                _c("p", [
                  _vm._v(
                    " 请选择注销渠道（本页面提供的注销渠道均由第三方提供，仅供参考，如需了解详情，请前往各第三方应用内或该第三方应用隐私政策页面查看） "
                  )
                ]),
                _c(
                  "van-collapse",
                  {
                    staticClass: "collapse_content",
                    model: {
                      value: _vm.activeNames,
                      callback: function($$v) {
                        _vm.activeNames = $$v
                      },
                      expression: "activeNames"
                    }
                  },
                  _vm._l(_vm.channelList, function(item, i) {
                    return _c("van-collapse-item", {
                      key: i,
                      attrs: { title: item.title },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function() {
                              return [
                                _c("div", {
                                  domProps: { innerHTML: _vm._s(item.content) }
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    })
                  }),
                  1
                )
              ],
              1
            )
          : _vm._e(),
        _vm.currentIndex == 10
          ? _c(
              "div",
              { staticClass: "success" },
              [
                _c("img", {
                  attrs: {
                    src: require("assets/images/accountCenter/success@2x.png"),
                    alt: "",
                    srcset: ""
                  }
                }),
                _c("p", [_vm._v("操作成功")]),
                _c(
                  "p",
                  [
                    _vm._v(
                      " 您的雷霆账号" +
                        _vm._s(_vm.preIndex[1] == 1 ? "" : "游戏") +
                        "注销申请已经提交成功 距离成功注销时间剩余 "
                    ),
                    _c("van-count-down", {
                      attrs: {
                        time: _vm.logOffInfo.remainTime,
                        format: "DD 天 HH 时 mm 分"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "van-button",
                  {
                    staticClass: "formClass_btn",
                    attrs: {
                      round: "",
                      block: "",
                      type: "info",
                      color: "#616edf"
                    },
                    on: {
                      click: function($event) {
                        _vm.cancelLogout(_vm.getCancelFlag())
                      }
                    }
                  },
                  [_vm._v("取消注销")]
                ),
                _vm.$isFlag
                  ? _c("p", { on: { click: _vm.goHome } }, [_vm._v("返回首页")])
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _vm.bottomConfirm
          ? _c("div", { staticClass: "prompt" }, [
              _c("p", [_vm._v("温馨提示：")]),
              _c("p", [_vm._v("1、本页面功能仅限雷霆账号使用")]),
              _c("p", [
                _vm._v(
                  "2、在账号注销期间请保持绑定手机的使用，不要进行更改或注销"
                )
              ]),
              _c("p", [
                _vm._v(
                  " 3、使用此功能前，账号的绑定安全手机需要≥7天，如果是新账号的话只需未更换过绑定手机即可。 "
                )
              ]),
              _c("p", [
                _vm._v("4、账号注销成功之后，获得的雷霆客服服务特权将会清空。")
              ]),
              _c("p", [_vm._v("5、账号注销成功之后，雷霆官方论坛将无法登录。")])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "textClass" }, [
        _vm._v(
          "为保障您的个人信息与财产安全，维护公平健康的游戏环境，在您向雷霆公司申请注销雷霆账号之前，请务必仔细阅读并充分理解本须知。"
        ),
        _c("span", { staticClass: "colorBlack" }, [
          _vm._v(
            "注销账号是不可逆操作，一旦成功，您的账号信息、角色数据、虚拟资产及相关记录将按法律法规要求被删除或匿名化处理（法律法规另有规定的除外），且无法恢复。"
          )
        ])
      ]),
      _c("br"),
      _c("span", { staticClass: "textClass" }, [
        _vm._v("您应确保您申请注销的雷霆账号已经同时具备以下全部条件：")
      ]),
      _c("br"),
      _c("span", { staticClass: "classSj" }, [
        _c("span", { staticClass: "dot" }, [_vm._v(" a . ")]),
        _c("span", { staticClass: "colorBlack" }, [
          _vm._v("账号状态正常且无未解除处罚：账号未被采取任何违规处罚措施")
        ]),
        _vm._v(
          "(包括但不限于因违反雷霆公司相关协议、规则而被处以的账号封停、账号部分功能受限等)。 "
        ),
        _c("span", { staticClass: "colorRed" }, [
          _vm._v(
            "特别说明：账号若因违规行为（如使用外挂、打金工作室行为、扰乱游戏秩序、诈骗等）处于处罚期内，或涉及重大安全风险被冻结，将无法注销。 "
          )
        ])
      ]),
      _c("br"),
      _c("span", { staticClass: "classSj" }, [
        _c("span", { staticClass: "dot" }, [_vm._v(" b . ")]),
        _c("span", { staticClass: "colorBlack" }, [
          _vm._v("账号安全无虞：账号状态安全，")
        ]),
        _vm._v("不存在被盗号风险及其他安全风险状态中，"),
        _c("span", { staticClass: "colorBlack" }, [
          _vm._v("且近一周内没有变更账号绑定信息（如手机号码等）等操作记录。 ")
        ])
      ]),
      _c("br"),
      _c("span", { staticClass: "classSj" }, [
        _c("span", { staticClass: "dot" }, [_vm._v(" c . ")]),
        _c("span", { staticClass: "colorBlack" }, [
          _vm._v("无未决纠纷与法律风险：账号近一个月内不涉及任何未解决的纠纷，")
        ]),
        _vm._v("包括但不限于投诉、举报、诉讼、仲裁等； "),
        _c("span", { staticClass: "colorRed" }, [
          _vm._v(
            "特别强调：账号如因涉及违反法律法规（包括但不限于传播违法违规信息、危害国家安全与社会稳定内容等）被永久封停，雷霆公司有义务依据《网络安全法》、《反电信网络诈骗法》等相关法律法规保留相关数据并配合监管调查，此类账号将无法注销。 "
          )
        ])
      ]),
      _c("br"),
      _c("span", { staticClass: "classSj" }, [
        _c("span", { staticClass: "dot" }, [_vm._v(" d . ")]),
        _c("span", { staticClass: "colorBlack" }, [_vm._v("履行法定义务：")]),
        _c("span", [
          _vm._v(
            "账号注销不违反雷霆公司需遵守的任何现行有效的法律法规、司法裁决、行政命令或监管要求（例如配合犯罪调查、处理违法违规信息）。 "
          )
        ])
      ]),
      _c("br"),
      _c("span", { staticClass: "classSj" }, [
        _c("span", { staticClass: "dot" }, [_vm._v(" e . ")]),
        _vm._v(
          " 雷霆公司公布的其他注销条件（如有）：请留意雷霆公司官方网站发布的最新信息。 "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "textClass" }, [
        _vm._v(
          "您需要首先尝试自行核实并确认是否满足上述全部条件，如您无法自行处理或在处理过程中有任何疑问，可联系客服协助处理。但最终是否满足注销条件及能否注销，由雷霆公司根据账号状态、系统记录及法律法规综合判定。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "textClass" }, [
      _vm._v(
        " 雷霆游戏账号（下称“游戏账号”）是指深圳雷霆信息技术有限公司及其关联公司依据《雷霆游戏使用许可及用户协议》授权您用于登录、使用对应的雷霆游戏或相关服务的标识。"
      ),
      _c("span", { staticClass: "colorRed" }, [
        _vm._v(
          "请您在申请游戏账号注销前认真阅读并充分理解《雷霆账号注销须知》的"
        ),
        _c("span", { staticClass: "colorRed bold" }, [
          _vm._v("第2、3条内容，尤其是红色或加粗字体部分")
        ]),
        _vm._v("，该内容同样适用于本次注销申请")
      ]),
      _vm._v("； ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        " ● 2. 游戏的存档也是玩家的财产之一，玩家申请游戏注销后会有7天的确认期，到期之后账号会自动完成注销。"
      ),
      _c("span", { staticClass: "colorRed" }, [
        _vm._v(
          "但请注意，若您在约定的注销申请处理期间，使用该游戏账号登录或使用对应手游，则视为您撤销该游戏账号的注销申请；"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "colorRed bold textClass" }, [
        _vm._v(
          "请特别注意，注销游戏账号为不可恢复的操作，请您在注销游戏账号前务必点击查阅并充分理解《雷霆账号注销须知》的全部内容，尤其是红色或加粗字体部分。 "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "list_title" }, [
      _c("p", [_vm._v("游戏名")]),
      _c("p", [_vm._v("对应游戏是否有充值")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }